import { UseAppSelector } from "../configure-store";
/**
 * A redux state selector meant to be used with useSelector(). The app's entire state is
 * passed in and this drills down to specifically the apiKey.
 *
 * @param state
 */
// export const getFullName = createSelector((state: useAppSelector)=>
//     state.profile?.personalInformationData,(data)=>data?.fullName
// )

export function getPersonalInformationData(state: UseAppSelector) {
    return state.profile.personalInformationData;
}
export function getParticipantStatus(state: UseAppSelector) {
    return state.profile.personalInformationData?state.profile.personalInformationData.participantStatus: null;
}

export function getIsParticipantTerminated(state: UseAppSelector) {
    return state.profile.personalInformationData?state.profile.personalInformationData.terminated: null;
}
export function getIsPersonalInformationDataLoaded(state: UseAppSelector) {
    return state.profile.isPersonalInformationDataLoaded;
}
export function getIsPersonalInformationDataLoadedRejected(state: UseAppSelector) {
    return state.profile.isPersonalInformationDataLoadedRejected;
}
export function getReceivedPlansData(state: UseAppSelector) {
    return state.profile.plansData?state.profile.plansData : null;
}
export function getSelectedPlan(state: UseAppSelector) {
    return state.profile.selectedPlan ? state.profile.selectedPlan : null;
}

export function getIsPlansDataLoaded(state: UseAppSelector) {
    return state.profile.isPlansDataLoaded;
}

export function getEmailAddress(state: UseAppSelector) {
    return state.profile.emailAddressObject.emailAddressData.emailAddress?state.profile.emailAddressObject.emailAddressData.emailAddress:'';
}

export function getUpdatedEmailAddress(state: UseAppSelector) {
    return state.profile.emailAddressObject.updatedEmailAddress?state.profile.emailAddressObject.updatedEmailAddress:'';
}
export function getEmailDeliveryStatus(state: UseAppSelector) {
    return state.profile.emailAddressObject.emailAddressData.undeliverable?state.profile.emailAddressObject.emailAddressData.undeliverable:'';
}

export function getIsEditEmailMode(state: UseAppSelector) {
    return state.profile.emailAddressObject.isEditEmailMode?state.profile.emailAddressObject.isEditEmailMode:'';
}

export function getIsEmailAddressValid(state: UseAppSelector) {
    return state.profile.emailAddressObject.emailAddressValid?state.profile.emailAddressObject.emailAddressValid:'';
}

export function getIsGetEmailAddressLoaded(state: UseAppSelector) {
    return state.profile.emailAddressObject.isGetEmailAddressLoaded;
}
export function getIsGetEmailAddressLoadedRejected(state: UseAppSelector) {
    return state.profile.emailAddressObject.isGetEmailAddressLoadedRejected;
}

export function getIsPlanProfileOlaMessageData(state: UseAppSelector) {
    return state.profile.planProfileOlaMessageData?.stringValue;
}

export function getIsPlanProfileOlaMessageDataLoaded(state: UseAppSelector) {
    return state.profile.isPlanProfileOlaMessageDataLoaded;
}

export function getIsPlanProfileOlaMessageDataLoadedRejected(state: UseAppSelector) {
    return state.profile.isPlanProfileOlaMessageDataLoadedRejected;
}

export function getIsSempraPlan(state: UseAppSelector){
    return state.profile.isSempraPlan;
}

export function getIsSempraActivePlanNameOlaMsg(state: UseAppSelector) {
    return state.profile.sempraActivePlanNameOlaMsg?.stringValue;
}

export function getIsSempraActivePlanNameOlaMsgDataLoaded(state: UseAppSelector) {
    return state.profile.isSempraActivePlanNameOlaMsgDataLoaded;
}

export function getIsSempraActivePlanNameOlaMsgDataLoadedRejected(state: UseAppSelector) {
    return state.profile.isSempraActivePlanNameOlaMsgDataLoadedRejected;
}

export function getIsSempraTerminatedPlanNameOlaMsg(state: UseAppSelector) {
    return state.profile.sempraTerminatedPlanNameOlaMsg?.stringValue;
}

export function getIsSempraTerminatedPlanNameOlaMsgDataLoaded(state: UseAppSelector) {
    return state.profile.isSempraTerminatedPlanNameOlaMsgDataLoaded;
}

export function getIsSempraTerminatedlanNameOlaMsgDataLoadedRejected(state: UseAppSelector) {
    return state.profile.isSempraTerminatedPlanNameOlaMsgDataLoaded;
}

export function getIsParticipantTerminateOlaMessageDataLoaded(state: UseAppSelector) {
    return state.profile.isParticipantTerminateOlaMessageDataLoaded;
}

export function getIsParticipantTerminateOlaMessageDataLoadedRejected(state: UseAppSelector) {
    return state.profile.isParticipantTerminateOlaMessageDataLoadedRejected;
}

export function getParticipantTerminateOlaMessageValue(state: UseAppSelector) {
    return state.profile.participantTerminateOlaMessageData?.stringValue;
}

export function getIsPlansInfoDataLoaded(state: UseAppSelector) {
    return state.profile.isPlansInfoDataLoaded;
}
export function getIsPlansInfoDataLoadedRejected(state: UseAppSelector) {
    return state.profile.isPlansInfoDataLoadedRejected;
}
export function getIsBeneMcCAmishSwitchDataLoaded(state: UseAppSelector) {
    return state.profile.isBeneMcCAmishSwitchDataLoaded;
}

export function getIsBeneMcCAmishSwitchDataLoadedRejected(state: UseAppSelector) {
    return state.profile.isBeneMcCAmishSwitchDataLoadedRejected;
}

export function getMcCAmishSwitch(state: UseAppSelector) {
    return state.profile.beneMcCAmishSwitchData?state.profile.beneMcCAmishSwitchData.stringValue:'';
}

export function getTracPlan(state: UseAppSelector) {
    return state.profile.plansInfoData?state.profile.plansInfoData[0]?.tracPlan : null;
}

export function getCenturyPlan(state: UseAppSelector) {
    return state.profile.plansInfoData?state.profile.plansInfoData[0]?.centuryPlan : null;
}

export function getIsPlansRulesDataLoaded(state: UseAppSelector) {
    return state.profile.isPlansRulesDataLoaded;
}
export function getIsPlansRulesDataLoadedRejected(state: UseAppSelector) {
    return state.profile.isPlansRulesDataLoadedRejected;
}
export function getOnlineBeneficiary(state: UseAppSelector) {
    return state.profile.plansRulesData?state.profile.plansRulesData[0]?.onlineBeneficiary : null;
}

export function getOnlineStatements(state: UseAppSelector) {
    return state.profile.plansRulesData?state.profile.plansRulesData[0]?.onLineStatements : null;
}

export function getPaperlessStatement(state: UseAppSelector) {
    return state.profile.plansRulesData?state.profile.plansRulesData[0]?.paperlessStatement : null;
}

export function getPaperlessPlanFeeDisclosures(state: UseAppSelector) {
    return state.profile.plansRulesData?state.profile.plansRulesData[0]?.paperlessPlanFeeDisclosures : null;
}

export function getPaperlessPlanLegalNotices(state: UseAppSelector) {
    return state.profile.plansRulesData?state.profile.plansRulesData[0]?.paperlessPlanLegalNotices : null;
}

export function getPaperlessProxyStatement(state: UseAppSelector) {
    return state.profile.plansRulesData?state.profile.plansRulesData[0]?.paperlessProxyStatement : null;
}

export function getDailyPrices(state: UseAppSelector) {
    return state.profile.plansRulesData?state.profile.plansRulesData[0]?.fundMarketInfo : null;
}

export function getMonthlyPerformance(state: UseAppSelector) {
    return state.profile.plansRulesData?state.profile.plansRulesData[0]?.prices : null;
}

export function getIsPlanNonQualified(state: UseAppSelector) {
    return state.profile.plansRulesData?state.profile.plansRulesData[0]?.isPlanNonQualified : null;
}

export function getIsAllowBeneficiaryUpdates(state: UseAppSelector) {
    return state.profile.plansRulesData?state.profile.plansRulesData[0]?.allowBeneficiaryUpdates : null;
}

export function getPlanRulesData(state: UseAppSelector) {
    return state.profile.plansRulesData ? state.profile.plansRulesData : [];
}

export function getBeneficiaryData(state: UseAppSelector) {
    return state.profile.participantBeneficiaryData;
}

export function getIsParticipantBeneficiaryDataLoaded(state: UseAppSelector) {
    return state.profile.isParticipantBeneficiaryDataLoaded;
}
export function getIsParticipantBeneficiaryDataRejected(state: UseAppSelector) {
    return state.profile.isParticipantBeneficiaryDataRejected;
}
export function getIsBeneficiaryArray(state: UseAppSelector) {
    return state.profile.participantBeneficiaryData?state.profile.participantBeneficiaryData.beneficiaryArray:[];
}

export function getDefinedBenefitParticipantBeneficiariesData(state: UseAppSelector) {
    return state.profile.definedBenefitParticipantBeneficiariesData;
}
export function getIsDefinedBenefitParticipantBeneficiariesDataLoaded(state: UseAppSelector) {
    return state.profile.isDefinedBenefitParticipantBeneficiariesDataLoaded;
}

export function getIsDefinedBenefitParticipantBeneficiariesDataLoadedRejected(state: UseAppSelector) {
    return state.profile.isDefinedBenefitParticipantBeneficiariesDataLoadedRejected;
}
export function getDefinedParticipantBenesArray(state: UseAppSelector) {
    return state.profile.definedBenefitParticipantBeneficiariesData ? state.profile.definedBenefitParticipantBeneficiariesData.definedParticipantBenes : [];
}
export function getDefinedParticipantLastBeneUpdateDate(state: UseAppSelector) {
    return state.profile.definedBenefitParticipantBeneficiariesData ? state.profile.definedBenefitParticipantBeneficiariesData.lastBeneUpdate : '';
}
export function getMobileNumber(state: UseAppSelector) {
    return state.profile.mobileNumberObject.mobileNumber?state.profile.mobileNumberObject.mobileNumber.replace(/(\d{3})?(\d{3})(\d{4})$/, "$1-$2-$3") : '';
}
export function getUpdatedMobileNumber(state: UseAppSelector) {
    return state.profile.mobileNumberObject.updatedMobileNumber ? state.profile.mobileNumberObject.updatedMobileNumber : '';
}
export function getIsUpdatePhoneNumberRejected(state: UseAppSelector) {
    return state.profile.mobileNumberObject.isUpdatePhoneNumberRejected;
}
export function getIsSavePhoneNumberRejected(state: UseAppSelector) {
    return state.profile.mobileNumberObject.isSavePhoneNumberRejected;
}
export function getIsActivationCodeLoaded(state: UseAppSelector) {
    return state.profile.mobileNumberObject.isActivationCodeLoaded ? state.profile.mobileNumberObject.isActivationCodeLoaded : '';
}

export function isMobileNumberValid(state: UseAppSelector) {
    return state.profile.mobileNumberObject.mobileNumberValid?state.profile.mobileNumberObject.mobileNumberValid:'';
}
export function getIsEditMobileMode(state: UseAppSelector) {
    return state.profile.mobileNumberObject.isEditMobileMode?state.profile.mobileNumberObject.isEditMobileMode:'';
}
export function getIsUpdatePhoneNumberLoaded(state: UseAppSelector) {
    return state.profile.mobileNumberObject.isUpdatePhoneNumberLoaded;
}
export function getIsSavePhoneNumberLoaded(state: UseAppSelector) {
    return state.profile.mobileNumberObject.isSavePhoneNumberLoaded;
}
export function getIsSubmitActivationCodeLoaded(state: UseAppSelector) {
    return state.profile.mobileNumberObject.isSubmitActivationCodeLoaded;
}
export function getIsSubmitActivationCodeRejected(state: UseAppSelector) {
    return state.profile.mobileNumberObject.isSubmitActivationCodeRejected;
}
export function getShowSignUpForTextAlertsButton(state: UseAppSelector) {
    return state.profile.mobileNumberObject.showSignUpForTextAlertsButton;
}
export function getIsGetPhoneNumberLoaded(state: UseAppSelector) {
    return state.profile.mobileNumberObject.isGetPhoneNumberLoaded;
}
export function getIsGetPhoneNumberLoadedRejected(state: UseAppSelector) {
    return state.profile.mobileNumberObject.isGetPhoneNumberLoadedRejected;
}
export function getIsShowToggleButton(state: UseAppSelector) {
    return state.profile.mobileNumberObject.isShowToggleButton;
}
export function getIsClientProfileLoaded(state: UseAppSelector) {
    return state.profile.isClientProfileLoaded;
}
export function getIsClientProfileRejectedDataLoaded(state: UseAppSelector) {
    return state.profile.isClientProfileRejectedDataLoaded;
}
export function getIsSaveOrUpdateClientProfileRejected(state: UseAppSelector) {
    return state.profile.isSaveOrUpdateClientProfileRejected;
}
export function getIsEditAboutYourselfData(state: UseAppSelector){
    return state.profile.aboutYourselfData.isEditAboutYourselfData ? state.profile.aboutYourselfData.isEditAboutYourselfData : ''
}
export function getIsGetReferenceTypeValuesLoaded(state: UseAppSelector){
    return state.profile.aboutYourselfData.isGetReferenceTypeValuesLoaded;
}
export function getIsGetReferenceTypeValuesLoadedRejected(state: UseAppSelector){
    return state.profile.aboutYourselfData.isGetReferenceTypeValuesLoadedRejected;
}
export function getInvestmentExpOptions(state: UseAppSelector){
    return state.profile.aboutYourselfData.investmentExpOptions ? state.profile.aboutYourselfData.investmentExpOptions : null
}
export function getInvestmentGoalOptions(state: UseAppSelector){
    return state.profile.aboutYourselfData.investmentGoalOptions ? state.profile.aboutYourselfData.investmentGoalOptions : null
}

export function getUpdatedGender(state: UseAppSelector){
    return state.profile.aboutYourselfData.updatedGender ? state.profile.aboutYourselfData.updatedGender : null
}

export function getUpdatedInvExpLevel(state: UseAppSelector){
    return state.profile.aboutYourselfData.updatedInvestmentExpLevel ? state.profile.aboutYourselfData.updatedInvestmentExpLevel : null
}

export function getUpdatedInvestmentGoals(state: UseAppSelector){
    return state.profile.aboutYourselfData.updatedInvestmentGoals ? state.profile.aboutYourselfData.updatedInvestmentGoals : []
}
export function getCurrentScreen(state: UseAppSelector){
    return state.profile.currentScreen
}

export function getIsEditSubscriptionEmail(state: UseAppSelector){
    return state.profile.emailAddressObject.isEditSubscriptionEmail;
}

export function getUpdatedSubscriptionEmail(state: UseAppSelector) {
    return state.profile.emailAddressObject.updatedSubscriptionEmail?state.profile.emailAddressObject.updatedSubscriptionEmail:'';
}

export function getIsSubscriptionEmailValid(state: UseAppSelector) {
    return state.profile.emailAddressObject.isSubscriptionEmailValid;
}

export function getIsSubscriptionEmailError(state: UseAppSelector) {
    return state.profile.emailAddressObject.isSubscriptionEmailError;
}

export function getIsEmailAddressError(state: UseAppSelector) {
    return state.profile.emailAddressObject.isEmailAddressError;
}
export function getIsUpdateEmailAddressRejected(state: UseAppSelector) {
    return state.profile.emailAddressObject.isUpdateEmailAddressRejected;
}
export function getIsEmailNotOnFileError(state: UseAppSelector) {
    return state.profile.emailAddressObject.isEmailNotOnFileError;
}
export function getAlwaysChallenge(state: UseAppSelector) {
    return state.profile.alwaysChallenge;
}

export function getIsProfileMfaDataLoaded(state: UseAppSelector) {
    return state.profile.isProfileMfaDataLoaded;
}
export function getIsProfileMfaDataRejected(state: UseAppSelector) {
    return state.profile.isProfileMfaDataRejected;
}
export function getIsParticipantConsentDataLoaded(state: UseAppSelector) {
    return state.profile.isParticipantConsentDataLoaded;
}
export function getIsParticipantConsentDataRejected(state: UseAppSelector) {
    return state.profile.isParticipantConsentDataRejected;
}
export function getParticipantConsentData(state: UseAppSelector) {
    return state.profile.participantConsentData ? state.profile.participantConsentData : [];
}

export function getUserPreferencesData(state: UseAppSelector) {
    return state.profile.userPreferences;
}

export function getTaxRateBrackets(state: UseAppSelector){
    return state.profile.taxRateBrackets ? state.profile.taxRateBrackets : [];
}
export function getIsTaxRateBracketsDataLoaded(state: UseAppSelector){
    return state.profile.isTaxRateBracketsDataLoaded;
}
export function getIsTaxRateBracketsDataRejected(state: UseAppSelector){
    return state.profile.isTaxRateBracketsDataRejected;
}
export function getIsEditPlanInfoMode(state: UseAppSelector){
    return state.profile.planningInformation.isEditPlanInfoMode ? state.profile.planningInformation.isEditPlanInfoMode : ''
}

export function getClientProfile(state: UseAppSelector){
    return state.profile.clientProfile ? state.profile.clientProfile : null;
}
export function getIsAnnualSalaryError(state: UseAppSelector){
    return state.profile.planningInformation.isAnnualSalaryError;
}

export function getIsRetirementAgeError(state: UseAppSelector){
    return state.profile.planningInformation.isRetirementAgeError;
}

export function getIsMarginalTaxRateError(state: UseAppSelector){
    return state.profile.planningInformation.isMarginalTaxRateError;
}
export function getRetirementIncomeScenario(state: UseAppSelector){
    return state.profile.planningInformation.retirementIncomeScenario ? state.profile.planningInformation.retirementIncomeScenario : [];
}
export function getCompensations(state: UseAppSelector){
    return state.profile.planningInformation.compensations ? state.profile.planningInformation.compensations : [];
}
export function getIsCompensationsDataLoaded(state: UseAppSelector){
    return state.profile.planningInformation.compensationsDataLoaded;
}
export function getIsCompensationsDataRejected(state: UseAppSelector){
    return state.profile.planningInformation.compensationsDataRejected;
}
export function getIsUpdateCompensationsRejected(state: UseAppSelector){
    return state.profile.planningInformation.isUpdateCompensationsRejected;
}
export function getIsSaveRixSalaryPayFrequencyRejected(state: UseAppSelector){
    return state.profile.planningInformation.isSaveRixSalaryPayFrequencyRejected;
}
export function getIsSaveOrUpdateRiSimulationRejected(state: UseAppSelector){
    return state.profile.planningInformation.isSaveOrUpdateRiSimulationRejected;
}
export function getIsRixScenarioLoaded(state: UseAppSelector) {
    return state.profile.planningInformation.isRixScenarioLoaded;
}
export function getIsRixScenarioRejectedDataLoaded(state: UseAppSelector) {
    return state.profile.planningInformation.isRixScenarioRejectedDataLoaded;
}
export function getUpdatedAnnualSalary(state: UseAppSelector){
    return state.profile.planningInformation.updatedAnnualSalary ? state.profile.planningInformation.updatedAnnualSalary : ''
}
export function getMultiClientCompensation(state: UseAppSelector){
    return state.profile.planningInformation.multiClientCompensation;
}
export function getUpdatedRetirementAge(state: UseAppSelector){
    return state.profile.planningInformation.updatedRetirementAge ? state.profile.planningInformation.updatedRetirementAge : ''
}

export function getUpdatedMarginalTaxRate(state: UseAppSelector){
    return state.profile.planningInformation.updatedMarginalTaxRate ? state.profile.planningInformation.updatedMarginalTaxRate : ''
}

export function getUpdatedPaycheckFrequency(state: UseAppSelector){
    return state.profile.planningInformation.updatedPaycheckFrequency ? state.profile.planningInformation.updatedPaycheckFrequency : ''
}
export function getPaycheckFrequencyOptions(state: UseAppSelector){
    return state.profile.planningInformation.paycheckFrequencyOptions ? state.profile.planningInformation.paycheckFrequencyOptions : null
}

export function getIsPricesInvOptionsChecked(state: UseAppSelector){
    return state.profile.isPricesInvOptionsChecked;
}

export function getIsPerformanceInvOptionsChecked(state: UseAppSelector){
    return state.profile.isPerformanceInvOptionsChecked;
}
export function getSelectedPricesServiceProducts(state: UseAppSelector){
    return state.profile.selectedPricesServiceProducts ? state.profile.selectedPricesServiceProducts : [];
}

export function getSelectedPerformanceServiceProducts(state: UseAppSelector){
    return state.profile.selectedPerformanceServiceProducts ? state.profile.selectedPerformanceServiceProducts : [];
}

export function getOtherRetirementPlanDataLoaded(state: UseAppSelector){
    return state.profile.isOtherRetirementPlanDataLoaded;
}
export function getOtherRetirementPlanDataRejected(state: UseAppSelector){
    return state.profile.isOtherRetirementPlanDataRejected;
}
export function getIsShowOrHideOtherRetirementPlansRejected(state: UseAppSelector){
    return state.profile.isShowOrHideOtherRetirementPlansRejected;
}
export function getOtherRetirementPlans(state: UseAppSelector){
    return state.profile.otherRetirementPlanData? state.profile.otherRetirementPlanData.otherRetirementPlans:null;
}

export function getShowOldRetirementplans(state: UseAppSelector){
    return state.profile.otherRetirementPlanData.showOldRetirementPlans;
}

export function getServiceStatus(state: UseAppSelector){
    return state.profile.serviceStatus ? state.profile.serviceStatus : null;
}
export function getDailyPricesInvOption(state: UseAppSelector){
    return state.profile.dailyPricesInvOption ? state.profile.dailyPricesInvOption : null;
}

export function getMonthlyPerformanceInvOption(state: UseAppSelector){
    return state.profile.monthlyPerformanceInvOption ? state.profile.monthlyPerformanceInvOption : null;
}

export function getIsServiceStatusDataLoaded(state: UseAppSelector){
    return state.profile.isServiceStatusDataLoaded;
}
export function getIsServiceStatusDataRejected(state: UseAppSelector){
    return state.profile.isServiceStatusDataRejected;
}
export function getAddConsentRequestData(state: UseAppSelector){
    return state.profile.addConsentRequestData;
}
export function getServiceStatusDailyPricesRequestData(state: UseAppSelector){
    return state.profile.serviceStatusDailyPricesRequestData;
}

export function getServiceStatusMonthlyPerformanceRequestData(state: UseAppSelector){
    return state.profile.serviceStatusMonthlyPerformanceRequestData;
}

export function getServiceProductDailyPricesRequestData(state: UseAppSelector){
    return state.profile.serviceProductDailyPricesRequestData;
}

export function getServiceProductMonthlyPerformanceRequestData(state: UseAppSelector){
    return state.profile.serviceProductMonthlyPerformanceRequestData;
}

export function getSaveDailyPricesPreferences(state: UseAppSelector){
    return state.profile.saveDailyPricesPreferences;
}
export function getSaveMonthlyPerformancePreferences(state: UseAppSelector){
    return state.profile.saveMonthlyPerformancePreferences;
}

export function getPutServiceCallForDailyPrices(state: UseAppSelector){
    return state.profile.putServiceCallForDailyPrices;
}

export function getPutServiceCallForMonthlyPerformance(state: UseAppSelector){
    return state.profile.putServiceCallForMonthlyPerformance;
}

export function getDeleteServiceCallForDailyPrices(state: UseAppSelector){
    return state.profile.deleteServiceCallForDailyPrices;
}

export function getDeleteServiceCallForMonthlyPerformance(state: UseAppSelector){
    return state.profile.deleteServiceCallForMonthlyPerformance;
}
export function getSaveDailyPricesInvestmentoptions(state: UseAppSelector){
    return state.profile.saveDailPricesInvestmentOptions;
}

export function getSaveMonthlyPerformanceInvestmentOptions(state: UseAppSelector){
    return state.profile.saveMonthlyPerformanceInvestmentOptions;
}


export function getIsPlanProductsDataLoaded(state: UseAppSelector){
    return state.profile.isPlanProductsDataLoaded;
}
export function getIsPlanProductsDataRejected(state: UseAppSelector){
    return state.profile.isPlanProductsDataRejected;
}
export function getIsServiceProductsDataLoaded(state: UseAppSelector){
    return state.profile.isServiceProductsDataLoaded;
}
export function getIsServiceProductsDataRejected(state: UseAppSelector){
    return state.profile.isServiceProductsDataRejected;
}
export function getPlanProducts(state: UseAppSelector){
    return state.profile.filteredPlanProducts ? state.profile.filteredPlanProducts : null;
}

export function getServiceProducts(state: UseAppSelector) {
    return state.profile.serviceProducts ? state.profile.serviceProducts : null;
}

export function getIsDailyPricesInvestmentError(state: UseAppSelector) {
    return state.profile.isDailyPricesInvestmentError;
}

export function getIsMonthlyPerformanceInvestmentError(state: UseAppSelector) {
    return state.profile.isMonthlyPerformanceInvestmentError;
}

export function getIsDeleteServicesStatusRejectDataLoaded(state: UseAppSelector) {
    return state.profile.isDeleteServicesStatusRejectDataLoaded;
}

export function getIsShowSaveModal(state: UseAppSelector) {
    return state.profile.isShowSaveModal;
}

export function getRefreshPreferencesAndSubscriptions(state: UseAppSelector) {
    return state.profile.refreshPreferencesAndSubscription;
}
export function getIsSavePrefAndSubCallRejected(state: UseAppSelector) {
    return state.profile.isSavePrefAndSubCallRejected;
}

export function getNavigateToPreferencesAndSubscription(state: UseAppSelector) {
    return state.profile.navigateToPreferencesAndSubscription;
}


